import { useEffect } from "react";

import { AppConfig } from "@/config/app.config";
import { logger } from "@/util/logger";

export function SerwistRegistration() {
  useEffect(() => {
    if ("serviceWorker" in navigator && AppConfig.isProduction) {
      navigator.serviceWorker
        .register("/sw.js", { scope: "/" })
        .then((registration) => {
          logger.info("Service Worker registered with scope:", registration.scope);
        })
        .catch((error) => {
          logger.error("Service Worker registration failed:", error);
        });
    }
  }, []);

  return null;
}
